export const PRINTER_SUMMARY_LABELS = {
    time: 'Время',
    volume: 'Объём',
    savings: 'Экономия / перерасход',
    overuseDeduction: 'Вычет',
    bonus: 'Премия',
    printJobs: 'Задания печати',
} as const
